import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY } from '../../../../config/queries';
import { optionsPropTypes } from './SelectPropTypes';
import { isNumber } from '../../../../utils/number';
import {
  clearSuppliers,
  getSuppliers,
} from '../../../../actions/food/Supplier';

export const SupplierSelect = ({
  dispatchClearSuppliers,
  dispatchGetSuppliers,
  options,
  loading,
  input,
  meta,
  isDisabled,
  isClearable,
  isMulti,
  placeholder,
  noOptionsMessage,
}) => {
  useLayoutEffect(() => () => dispatchClearSuppliers(), []);

  const handleSupplierChange = (inputValue) => {
    if (inputValue.trim() && inputValue.trim().length >= 4) {
      const query = ['active:true'];

      if (isNumber(inputValue)) {
        query.push(`business.businessTaxId:${inputValue}`);
      } else {
        query.push(`business.name:${inputValue}`);
      }

      dispatchGetSuppliers({
        ...DEFAULT_QUERY,
        query,
      });
    }
  };

  return (
    <Select
      options={options}
      onInputChange={handleSupplierChange}
      isLoading={loading}
      input={input}
      meta={meta}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isMulti={isMulti}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage}
    />
  );
};

SupplierSelect.propTypes = {
  dispatchGetSuppliers: PropTypes.func.isRequired,
  dispatchClearSuppliers: PropTypes.func.isRequired,
  input: inputPropTypes,
  meta: metaPropTypes,
  options: optionsPropTypes,
  loading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.func,
};

SupplierSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  loading: false,
  isDisabled: false,
  isClearable: false,
  isMulti: false,
  options: [],
  placeholder: 'Buscar proveedor (RUC o nombre)',
  noOptionsMessage: undefined,
};

const mapStateToProps = ({ FoodUnit }) => ({
  options: FoodUnit.Supplier.getIn(['all', 'content', 'content']).map(
    ({ id, business }) => ({
      value: id,
      label: `${business.businessTaxId || ''} - ${business.name || ''}`,
      business,
    }),
  ),
  loading: FoodUnit.Supplier.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetSuppliers: getSuppliers,
  dispatchClearSuppliers: clearSuppliers,
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSelect);
